<template>
  <div class="dialog-character">
    <div class="dialog-character-normal" v-show="$bus.expand">
      <p class="dialog-character-text">{{ $bus.dialogCharacterText }}</p>
    </div>
    <div class="dialog-character-ellipsis" v-show="!$bus.expand" @click="show"></div>
  </div>
</template>

<script>
import { addGA } from '@/utils/assist'

export default {
  data () {
    return {
      timer: null
    }
  },
  methods: {
    hide () {
      clearTimeout(this.$bus.timer)
      this.$bus.timer = setTimeout(() => {
        this.$bus.expand = false
        clearTimeout(this.$bus.timer)
        this.$bus.timer = null
      }, 4000)
    },
    show () {
      addGA('show-character-dialog', 'click')
      this.$bus.updateDialogCharacterText()
    }
  },
  watch: {
    '$bus.dialogCharacterTextStatus': {
      handler (current) {
        this.$bus.updateDialogCharacterText()
      }
    },
    '$bus.expand': {
      handler (current) {
        if (current) {
          this.hide()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-character {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .dialog-character-normal {
    @include flexrc;
    position: absolute;
    @include px2res(left, 240);
    @include px2res(top,  55);
    @include px2res(width, 249);
    @include px2res(height, 187);
    @include px2res(padding, 25, 15, 60, 30);

    .dialog-character-text {
      color: $black;
      font-style: italic;
      font-family: $main-font-family;
      @include px2res(font-size, 19);
      transform: rotate(-14deg);
    }
  }

  .dialog-character-ellipsis {
    position: absolute;
    @include px2res(left, 240);
    @include px2res(top, 225);
    @include px2res(width, 50);
    @include px2res(height, 46);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/character/dialog.vue